<template>
  <v-card>
    <v-card-title>
      <span class="headline">Engine Model</span>
    </v-card-title>
    <v-card-text>
      <message :messages="messages"></message>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 v-if="newEngModel">
            <v-text-field :label="labels.vesEngMod" v-model="vesEngModelForm.vesEngMod" :error-messages="errors.collect('vesEngMod')" data-vv-name="vesEngMod" :data-vv-as="labels.vesEngMod" v-validate="'required|param|max:8'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.vesEngMod}}</v-subheader>
            <div class="title">{{vesEngModelForm.vesEngMod}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.vesEngModDesc" v-model="vesEngModelForm.vesEngModDesc" :error-messages="errors.collect('vesEngModDesc')" data-vv-name="vesEngModDesc" :data-vv-as="labels.vesEngModDesc" v-validate="'required|entry|max:80'"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
      <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'newEngModel': Boolean,
    'vesEngModelForm': Object
  },
  data() {
    return {
      labels: {
        vesEngMod: 'Engine Model*',
        vesEngModDesc: 'Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vesEngModelForm.vesEngMod = undefined
      this.vesEngModelForm.vesEngModDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newEngModel) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURL = this.vesMenu.createVslEngMod
      if (apiURL) {
        this.submitting = false
        try {
          const result = await this.$http.post(apiURL, this.vesEngModelForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURL = this.vesMenu.updateVslEngMod
      if (apiURL) {
        this.submitting = false
        try {
          const result = await this.$http.put(apiURL, this.vesEngModelForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  computed: {
    vesMenu() {
      return this.$store.state.vessel.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
